import { useCallback } from 'react';

import { Paragraph } from '@/components/Paragraph';
import { formatPrice } from '@/utils/formatPrice';

import {
  StyledCheckbox,
  StyledLuggageTableRow,
  StyledLuggageType,
  StyledLuggageDetails,
  StyledLuggagePrice,
} from './styles';

import type { FlightOption } from '@/types/flights';

interface LuggageOptionProps {
  flightOption: FlightOption;
  options: FlightOption[];
}

export function LuggageOption({ flightOption, options }: LuggageOptionProps) {
  const calculateDifference = useCallback(
    (option: FlightOption) => {
      const selectedOption = options.find((opt) => opt.selected);
      if (!selectedOption) return 0;

      const difference = option.price - selectedOption.price;
      const formattedDifference = formatPrice(difference);

      return difference > 0 ? `+${formattedDifference}` : formattedDifference;
    },
    [options],
  );

  return (
    <StyledLuggageTableRow key={flightOption.listId}>
      <StyledLuggageType>
        <StyledCheckbox checked={flightOption.selected} />
        <Paragraph weight={700}>{flightOption.name}</Paragraph>
      </StyledLuggageType>
      <StyledLuggageDetails>
        <Paragraph>{flightOption.description}</Paragraph>
      </StyledLuggageDetails>
      <StyledLuggagePrice>
        {!flightOption.selected && (
          <Paragraph weight={700} color="primary">
            {calculateDifference(flightOption)}
          </Paragraph>
        )}
      </StyledLuggagePrice>
    </StyledLuggageTableRow>
  );
}
